import { render } from "./RetirerAgent.vue?vue&type=template&id=62887cb8&scoped=true&ts=true"
import script from "./RetirerAgent.vue?vue&type=script&lang=ts"
export * from "./RetirerAgent.vue?vue&type=script&lang=ts"

import "./RetirerAgent.vue?vue&type=style&index=0&id=62887cb8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62887cb8"]])

export default __exports__